/* CopperTheory v42: turn v40 master copy into the premium v41-style layout without changing copy. */
(function(){
  'use strict';

  function directChildrenBetween(start, stopTag){
    var nodes=[];
    var node=start.nextElementSibling;
    while(node && node.tagName.toLowerCase()!==stopTag){nodes.push(node);node=node.nextElementSibling;}
    return nodes;
  }

  function titleKey(text){return (text||'').trim().toLowerCase();}
  function hasAny(text, words){return words.some(function(word){return text.indexOf(word)!==-1;});}

  function makeHero(root){
    var h2=root.querySelector(':scope > h2');
    if(!h2){return;}
    var hero=document.createElement('div');
    hero.className='ct-v42-hero';
    var kicker=document.createElement('span');
    kicker.className='ct-v42-kicker';
    kicker.textContent='CopperTheory Product Guide';
    hero.appendChild(kicker);
    root.insertBefore(hero,root.firstChild);
    hero.appendChild(h2);
    while(hero.nextElementSibling && hero.nextElementSibling.tagName.toLowerCase()!=='h3'){
      hero.appendChild(hero.nextElementSibling);
    }
  }

  function buildGroups(root){
    var headings=Array.prototype.slice.call(root.querySelectorAll(':scope > h3'));
    headings.forEach(function(h3,index){
      var block=document.createElement('section');
      block.className='ct-v42-block';
      if(index%2===1){block.classList.add('ct-v42-soft');}
      root.insertBefore(block,h3);
      block.appendChild(h3);
      while(block.nextElementSibling && block.nextElementSibling.tagName.toLowerCase()!=='h3'){
        block.appendChild(block.nextElementSibling);
      }
      enhanceBlock(block);
    });
  }

  function ingredientCards(block){
    var h4s=Array.prototype.slice.call(block.querySelectorAll(':scope > h4'));
    if(!h4s.length){return false;}
    var grid=document.createElement('div');
    grid.className='ct-v42-ingredient-grid';
    block.insertBefore(grid,h4s[0]);
    h4s.forEach(function(h4){
      if(h4.parentElement!==block){return;}
      var card=document.createElement('article');
      card.className='ct-v42-ingredient-card';
      grid.appendChild(card);
      var next=h4.nextElementSibling;
      card.appendChild(h4);
      while(next && next.parentElement===block && next.tagName.toLowerCase()!=='h4'){
        var move=next;next=next.nextElementSibling;card.appendChild(move);
      }
    });
    return true;
  }

  function faqAccordion(block){
    var h4s=Array.prototype.slice.call(block.querySelectorAll(':scope > h4'));
    if(!h4s.length){return false;}
    var list=document.createElement('div');
    list.className='ct-v42-faq-list';
    block.insertBefore(list,h4s[0]);
    h4s.forEach(function(h4){
      if(h4.parentElement!==block){return;}
      var details=document.createElement('details');
      var summary=document.createElement('summary');
      summary.innerHTML=h4.innerHTML;
      var answer=document.createElement('div');
      answer.className='ct-v42-faq-answer';
      var next=h4.nextElementSibling;
      h4.remove();
      while(next && next.parentElement===block && next.tagName.toLowerCase()!=='h4'){
        var move=next;next=next.nextElementSibling;answer.appendChild(move);
      }
      details.appendChild(summary);details.appendChild(answer);list.appendChild(details);
    });
    return true;
  }

  function enhanceBlock(block){
    var heading=block.querySelector(':scope > h3');
    var key=titleKey(heading?heading.textContent:'');

    if(hasAny(key,['full ingredients','full inci','ingredients (inci)'])){
      block.classList.add('ct-v42-inci');
    }

    if(hasAny(key,['frequently asked','questions'])){
      faqAccordion(block);
      return;
    }

    if(hasAny(key,['ingredient','formula','cleansing system','hair and scalp support','known key'])){
      ingredientCards(block);
    }

    var lists=Array.prototype.slice.call(block.querySelectorAll(':scope > ul, :scope > ol'));
    lists.forEach(function(list){
      if(hasAny(key,['how to use','routine order','daily and weekly routine','wash-day routine','non-wash-day routine'])){
        list.classList.add('ct-v42-steps');
      }else if(hasAny(key,['explore more'])){
        list.classList.add('ct-v42-links');
      }else{
        list.classList.add('ct-v42-list-grid');
      }
    });

    if(hasAny(key,['explore more'])){
      block.classList.add('ct-v42-explore');
      Array.prototype.slice.call(block.querySelectorAll(':scope > p')).forEach(function(p){if(p.querySelector('em')){p.classList.add('ct-v42-note');}});
    }
  }

  function enhanceRoot(root){
    if(root.dataset.ctV42Enhanced==='true'){return;}
    root.dataset.ctV42Enhanced='true';
    root.classList.add('ct-v42-ready');
    if(root.classList.contains('ct-v40-master--content')){makeHero(root);}
    buildGroups(root);
    Array.prototype.slice.call(root.querySelectorAll(':scope > p')).forEach(function(p){
      if(p.querySelector('em')){p.classList.add('ct-v42-note');}
    });
  }

  function init(){
    document.querySelectorAll('.ct-v40-master').forEach(enhanceRoot);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{init();}
  document.addEventListener('shopify:section:load',init);
})();
